<template>
    <div>
        <div v-if="!isMobile" class="tableCardBox">
            <div class="tableCard" v-for="(maq,index) in list" :key="index">
                <div class="header">
                    <el-image
                        class="logo"
                        :style="active!=1?'margin-left:.2rem;height:6vw;width: 10vw':''"
                        :src="maq.vendeur_logo"
                        fit="scale-down"
                        :lazy='true'
                        alt>
                        <div slot="error" style="text-align: center;padding-top: 20%">
                            <span>{{ maq.nomSociete }}</span>
                        </div>
                    </el-image>
                    <div>
                        <p>{{ langPage['v4-panier']['TXT_grossiste'] }}</p>
                        <span>{{ maq.nomSociete }}</span>
                    </div>
                    <div>
                        <p>{{ langPage['compte-commandes-virement-details']['TXT_tva'] }}</p>
                        <span>{{ parseFloat(maq.tva).toFixed(2) }} €</span>
                        <!-- <span>{{maq.tvaTotals}} €</span> -->
                    </div>
                    <div>
                        <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase() }}</p>
                        <span>{{ parseFloat(maq.montantApresRemise).toFixed(2) }} €</span>
                        <!-- <span>{{maq.htTotals}} €</span> -->
                    </div>
                    <div>
                        <p>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'].toUpperCase() }}</p>
                        <span>{{ parseFloat(maq.ttc).toFixed(2) }} €</span>
                        <!-- <span>{{maq.ttcTotals}} €</span> -->
                    </div>
                    <div>
                        <p>{{ langPage['v4-panier']['TXT_qtetotal'] }}</p>
                        <span>{{ maq.qteTotals ? maq.qteTotals : '-' }}</span>
                        <!-- <span>{{maq.qteTotals || 0}}</span> -->
                    </div>
                    <div class="header-collap" @click="maq.actives=!maq.actives">
                        <span>{{ !maq.actives ? 'Voir plus' : 'Voir moins' }}</span>
                        <i class="el-icon-arrow-up" v-if="maq.actives"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                    </div>
                </div>

                <el-collapse-transition>
                    <div v-if="maq.actives" class="cont">
                        <div class="flex" v-for="(prod,i) in  maq.childrens.produits" :key="i">
                            <el-image :lazy='true' class="img" fit="cover" :src="prod.produit_url"></el-image>
                            <div class="left">
                                <div class="item color">
                                    <p>{{ prod.reference }}</p>
                                    <div class="cercle">
                                    <span
                                        :style="{backgroundColor:!prod.couleur_value || typeof prod.couleur_value==='string'?prod.couleur_value:prod.couleur_value[0]}"></span>
                                        <div>
                                            {{
                                                !prod.couleur_name || typeof prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                            }}
                                        </div>
                                    </div>
                                    <!--                                <span class="tips">{{ langPage['v4-panier']['TXT_sauvegarderpourplustard'] }}</span>-->
                                </div>
                                <div class="size">
                                    <div class="sku">
                                        <div v-for="(size,sizeIndex) in prod.sizeList"
                                             class="item"
                                             :key="sizeIndex">
                                            <p>{{ size.size }}</p>
                                            <span v-if="prod.vendu_par!='tailles'">{{ size.num * prod.copeText }}</span>
                                            <span v-else type="text"
                                                  v-text="size.num"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="price">
                                    <div class="total">
                                        <div class="item" v-if="prod.vendu_par!='tailles'">
                                            <p>{{ langPage['produits']['TXT_paquets'] }}</p>
                                            <span>{{ prod.pack_qte }}</span>
                                            <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                            <span
                                                v-if="prod.vendu_par!=='tailles'">{{
                                                    prod.packTotal * prod.copeText
                                                }}</span>
                                            <span v-else>{{ prod.qteTotal }}</span>
                                            <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                            <span :class="{'item-other':prod.prixReduit}">{{ prod.prix }} €</span>
                                            <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] }}</p>
                                            <span v-if="prod.vendu_par!=='tailles'">
                                        {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                                }}€</span>
                                            <span
                                                v-else>{{
                                                    (prod.prixReduit ? prod.prixReduit * prod.qteTotal : prod.prix * prod.qteTotal)
                                                }}€</span>
                                        </div>
                                    </div>
                                </div>
                                <section class="line"></section>
                            </div>
                        </div>
                    </div>
                </el-collapse-transition>

            </div>
            <div class="bottom">
                <div class="left">
                    <div class="inp-warrp">
                        <el-input type="text" v-model="totalAppliquer"
                                  :placeholder="langPage['codepromo']['TXT_promotion']"/>
                        <span
                            @click="totalPromoCode">{{ langPage['filtres-grossiste']['BTN_Appliquer'] }}</span>
                    </div>
                    <div class="bottom-remscode" v-if="remiseState">
                        <p>{{ RemiseCode.code }} {{ '-' + parseInt(RemiseCode.montant) }}
                            {{ parseInt(RemiseCode.montant) + '%' }}</p>
                        <img src="../../../assets/img/cha.png" @click="closeRemiseState"/>
                    </div>
                </div>
                <div class="right">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_articlesht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalArtic ? totalNum.totalArtic.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-signpage']['TXT_transportht'] }}</span>
                        <p>{{ totalNum.totalTransport ? Number(totalNum.totalTransport).toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['boa-temp-vendeursfacturation']['TXT_remiseht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalRemise ? '-' + totalNum.totalRemise.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div v-if="totalNum.remiseTransport">
                        <span>{{ `REMISE TRANSPORT HT` }}</span>
                        <p>- {{ totalNum.remiseTransport.toFixed(2) }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalHtTotals ? totalNum.totalHtTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totaltva'] }}</span>
                        <p>{{ totalNum.totalTvaTotals ? totalNum.totalTvaTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalTtcTotals ? totalNum.totalTtcTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="mtableCardBox">
            <div class="tableCard" v-for="(maq,index) in list" :key="index">
                <div class="header">
                    <div class="left">
                        <el-row type="flex" align="middle">
                            <el-image
                                class="logo"
                                :src="maq.vendeur_logo"
                                fit="scale-down"
                                :lazy='true'
                                alt>
                                <div slot="error" style="text-align: center;padding-top: 20%">
                                    <span>{{ maq.nomSociete }}</span>
                                </div>
                            </el-image>
                        </el-row>
                        <section v-if="active!=1">
                            <div>
                                <div class="content">
                                    <p>{{ langPage['v4-panier']['TXT_grossiste'].toUpperCase() }}</p>
                                    <span>{{ maq.nomSociete }}</span>
                                </div>
                                <div class="content">
                                    <p>{{ langPage['compte-commandes-virement-details']['TXT_tva'] }}</p>
                                    <span>{{ parseFloat(maq.tva).toFixed(2) }} €</span>
                                    <!-- <span>{{maq.tvaTotals}} €</span> -->
                                </div>
                            </div>

                            <div>
                                <div class="content">
                                    <p>
                                        {{
                                            langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase()
                                        }}</p>
                                    <span>{{ parseFloat(maq.montantApresRemise).toFixed(2) }} €</span>
                                    <!-- <span>{{maq.htTotals}} €</span> -->
                                </div>
                                <div class="content">
                                    <p>
                                        {{
                                            langPage['compte-commandes-virement-details']['TXT_totalttc'].toUpperCase()
                                        }}</p>
                                    <span>{{ parseFloat(maq.ttc).toFixed(2) }} €</span>
                                    <!-- <span>{{maq.ttcTotals}} €</span> -->
                                </div>
                            </div>
                            <div class="content" v-if="maq.qteTotals&& maq.qteTotals!==`-`">
                                <p>{{ langPage['v4-panier']['TXT_qtetotal'] }}</p>
                                <span>{{ maq.qteTotals }}</span>
                                <!-- <span>{{maq.qteTotals || 0}}</span> -->
                            </div>
                        </section>
                    </div>
                    <div class="header-collap" @click="maq.actives=!maq.actives">
                        <span>{{ !maq.actives ? 'Voir plus' : 'Voir moins' }}</span>
                        <i class="el-icon-arrow-up" v-if="maq.actives"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                    </div>
                </div>
                <el-collapse-transition>
                    <div class="tableCard" v-if="maq.actives">
                        <!--                        <div class="Mettres">-->
                        <!--                            <el-row class="menu" type="flex" align="middle">-->
                        <!--                                <img src="@/assets/img/rotate-back.svg"/>-->
                        <!--                                <el-button class="btn">Mettre jour</el-button>-->
                        <!--                            </el-row>-->
                        <!--                            <el-row class="menu" type="flex" align="middle">-->
                        <!--                                <img src="@/assets/img/topMenu/Coeur.svg" alt="">-->
                        <!--                                <el-button class="btn" v-if="active===0" @click="move_to_handle_later(maq,i)">-->
                        <!--                                    Sauvegarder pour-->
                        <!--                                    plus-->
                        <!--                                    tard-->
                        <!--                                </el-button>-->
                        <!--                            </el-row>-->
                        <!--                            <el-row class="menu" type="flex" align="middle">-->
                        <!--                                <img src="@/assets/img/mobile/delete.svg">-->
                        <!--                                <el-button class="btn" @click="delSupprimer(maq,i)">Supprimer</el-button>-->
                        <!--                            </el-row>-->
                        <!--                        </div>-->
                        <div class="cont">
                            <template
                                v-if="maq.childrens && maq.childrens.produits && maq.childrens.produits.length>0">
                                <div class="container" v-for="(prod,i) in maq.childrens.produits" :key="i">
                                    <div class="productImgBox">
                                        <el-image
                                            :lazy='true'
                                            class="img"
                                            fit="cover"
                                            @click="$router.push(`/ProductDetail?id=${prod.id_produit}&vendu_par=${prod.vendu_par}&vid=${prod.id_vendeur}&categorie_id=${prod.id_categorie}`)"
                                            :src="prod.produit_url"></el-image>
                                        <div class="desc">
                                            <p>{{ prod.reference }}</p>
                                            <div class="cercle">
                                                <span
                                                    :style="{backgroundColor:!prod.couleur_value || typeof prod.couleur_value==='string'?prod.couleur_value:prod.couleur_value[0]}"></span>
                                                <div>{{
                                                        !prod.couleur_name || typeof prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                                    }}
                                                </div>
                                            </div>
                                            <!--                                            <span class="tips">{{-->
                                            <!--                                                    langPage['v4-panier']['TXT_sauvegarderpourplustard']-->
                                            <!--                                                }}</span>-->
                                        </div>
                                    </div>
                                    <el-divider></el-divider>
                                    <el-row type="flex" align="middle" class="size">
                                        <div class="sku">
                                            <div v-for="(size,sizeIndex) in prod.sizeList"
                                                 class="item"
                                                 :key="sizeIndex">
                                                <p>{{ size.size }}</p>
                                                <span
                                                    v-if="prod.vendu_par!='tailles'">{{
                                                        size.num * prod.copeText
                                                    }}</span>
                                                <input
                                                    type="text"
                                                    v-model="size.num"
                                                    v-else
                                                    @blur="tailBlur(prod,sizeIndex,maq)"
                                                    @input="tailInput(prod,size.num,sizeIndex)"
                                                    oninput="value=value.replace(/[^\d|0]/g, '')"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <el-row type="flex" align="middle" class="paquest"
                                                    v-show="prod.vendu_par!='tailles'">
                                                <p>{{ langPage['produits']['TXT_paquets'] }}</p>
                                                <span>{{ prod.copeText }}</span>
                                            </el-row>
                                        </div>
                                    </el-row>
                                    <el-divider></el-divider>
                                    <div class="price">
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                            <span
                                                v-if="prod.vendu_par!=='tailles'">{{
                                                    prod.packTotal * prod.copeText
                                                }}</span>
                                            <span v-else>{{ prod.qteTotal }}</span>
                                            <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                                        </div>
                                        <div class="item">
                                            <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                            <span :class="{'item-other':prod.prixReduit}">{{ prod.prix }} €</span>
                                            <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                                        </div>
                                        <div class="item">
                                            <p>
                                                {{
                                                    langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase()
                                                }}</p>
                                            <span v-if="prod.vendu_par!=='tailles'">
                                                            {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                                }}€</span>
                                            <span v-else>
                                                            {{
                                                    (prod.prixReduit ? prod.prixReduit * (prod.qteTotal) : prod.prix * (prod.qteTotal)).toFixed(2)
                                                }}€</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="bottom" v-if="active!=1">
                            <section>
                                <div class="flex">
                                    <div class="right">
                                        <div>
                                            <span>{{ langPage['v4-panier']['TXT_articlesht'] }}</span>
                                            <p>{{ maq.artic }} €</p>
                                        </div>
                                        <div>
                                            <span>{{
                                                    langPage['boa-temp-vendeursfacturation']['TXT_remiseht'].toUpperCase()
                                                }}</span>
                                            <p>{{ maq.remise == '0.00' ? maq.remise : '-' + maq.remise }} €</p>
                                        </div>
                                        <!-- <div>
                                          <span>transport HT</span>
                                          <p>888€</p>
                                        </div>-->
                                        <div>
                                            <span>{{
                                                    langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase()
                                                }}</span>
                                            <p>{{ maq.htTotals }} €</p>
                                        </div>
                                        <div v-if="maq.tvaTotals>0" style="display: block">
                                            <div>
                                                <span>{{ langPage['v4-panier']['TXT_totaltva'] }}</span>
                                                <p>{{ maq.tvaTotals }} €</p>
                                            </div>
                                            <div>
                                                <span>{{
                                                        langPage['compte-commandes-virement-details']['TXT_totalttc'].toUpperCase()
                                                    }}</span>
                                                <p>{{ maq.ttcTotals }} €</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="bottom">
                <div class="right">
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_articlesht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalArtic ? totalNum.totalArtic.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-signpage']['TXT_transportht'] }}</span>
                        <p>{{ totalNum.totalTransport ? Number(totalNum.totalTransport).toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['boa-temp-vendeursfacturation']['TXT_remiseht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalRemise ? '-' + totalNum.totalRemise.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div v-if="totalNum.remiseTransport">
                        <span>{{ `REMISE TRANSPORT HT` }}</span>
                        <p>- {{ totalNum.remiseTransport.toFixed(2) }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalht'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalHtTotals ? totalNum.totalHtTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['v4-panier']['TXT_totaltva'] }}</span>
                        <p>{{ totalNum.totalTvaTotals ? totalNum.totalTvaTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                    <div>
                        <span>{{ langPage['compte-commandes-virement-details']['TXT_totalttc'].toUpperCase() }}</span>
                        <p>{{ totalNum.totalTtcTotals ? totalNum.totalTtcTotals.toFixed(2) : '0.00' }} €</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";
import {Message} from "element-ui";

let commonUtils = require('@/utils/common_utils');
export default {
    name: "tableCard",
    props: {
        // list: [],
        // totalNum: {},
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            color: "red",
            totalNum: {},
            remiseCode: this.$store.state.queryRemiseCode,
            commandes_remises: this.$store.state.commandes_remises,
            commandes_remises2: [],
            tempRemiseMoney: 0,
            appliquer: "",
            totalAppliquer: "",
            remiseState: false,
            RemiseCode: {},
        };
    },
    computed: {
        ...mapState({
            acheteurId: state => state.acheteurId
        }),
        langPage() {
            return this.$store.state['langPage']
        }
    },
    watch: {
        totalNum(val) {
            this.$forceUpdate();
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData() {
            this.list = this.$store.state.order_confirm.orders;
            this.totalNum = this.$store.state.order_confirm.totalNum;
            console.log('totalNum tableCard', this.totalNum)
            //计算物流价格
            let deliver = this.$store.state.order_confirm.deliver;
            deliver.prix = Number(deliver.prix);
            let livraisonType = this.$store.state.order_confirm.livraisonType;
            if (livraisonType === 0) {
                //如果物流为 19 ups_group ups团发 且是第一次团发就设置物流价格为0;
                if (deliver.id_livraison > 19 && deliver.is_first_group) {
                    this.totalNum.totalTransport = 0;
                } else {
                    this.totalNum.totalTransport = deliver.prix > deliver.prix_remise && deliver.prix_remise ? deliver.prix_remise : deliver.prix;
                }
            } else if (livraisonType === 1) {
                this.totalNum.totalTransport = 0;
                //是团发且不是第一次团发就要算团发价格
                if (deliver.is_group && !deliver.is_first_group) {
                    this.totalNum.totalTransport = this.$store.state.partnerDeliverGroupPrice * this.$store.state.order_confirm.orders.length;
                }
            } else if (livraisonType === 2) {
                this.totalNum.totalTransport = 0;
            }
            this.totalNum.totalTransport = Number(this.totalNum.totalTransport);

            this.totalNum.totalTtcTotals += this.totalNum.totalTransport;
            let tax_rate = 0;//税率
            this.reduceRemises(this.RemiseCode);
            if (!commonUtils.isEmpty(this.commandes_remises)) {
                for (let commande_remise of this.commandes_remises) {
                    this.reduceRemises(commande_remise);
                }
                this.totalNum.totalRemise += this.tempRemiseMoney;
            }

            //税前总价 = 商品总价+物流总价-优惠金额
            this.totalNum.totalHtTotals = Number(Number(Number(this.totalNum.totalArtic)
                .add(this.totalNum.totalTransport))
                .del(this.totalNum.remiseTransport ? this.totalNum.remiseTransport : 0) //如果有物流减免就要扣掉
                .del(this.totalNum.totalRemise));//订单减免
            let resIsTva = await this.$api.order.get_buyer_is_tva({
                id_pays_livraison: this.$store.state.order_confirm.livraison.id_pays,
                id_pays_facturation: this.$store.state.order_confirm.facturation.id_pays
            });
            //获取到要扣税时计算税费
            if (resIsTva && resIsTva.code == 0 && resIsTva.data.isNeedTva) tax_rate = this.list[0].tax_rate;
            //税费=税前总价*税率
            this.totalNum.totalTvaTotals = Number(this.totalNum.totalHtTotals).mul(tax_rate);
            //税后总价=税前总价*（1+税率)
            this.totalNum.totalTtcTotals = Number(this.totalNum.totalHtTotals).mul(1 + tax_rate);

            this.$forceUpdate();
            console.log('order_confirm2', this.list, JSON.parse(JSON.stringify(this.totalNum)));
        },
        //减少优惠码的金额
        reduceRemises(remise={}) {
            if (remise.type == 'reduction') {
                if (remise.id_remise_type == 2) {//物流减免
                    this.totalNum.remiseTransport = this.totalNum.totalTransport.del(remise.montant);
                } else if (remise.id_remise_type == 1) {//订单减免
                    this.tempRemiseMoney = this.tempRemiseMoney.add(remise.montant);
                }
            } else if (remise.type == 'pourcentage') {
                if (remise.id_remise_type == 2) {//物流减免
                    this.totalNum.remiseTransport = this.totalNum.totalTransport.mul((Number(remise.montant)).div(100));
                } else if (remise.id_remise_type == 1) {//订单减免
                    let remiseMoeny = 0;
                    let commande = this.list.filter(order => {
                        return remise.id_commande == order.id_commande;
                    })[0];
                    let price = commande.montantTotal;
                    remiseMoeny = Number(price).mul(remise.montant).div(100);
                    console.log('remiseMoeny', price, remise, remiseMoeny, this.tempRemiseMoney)
                    this.tempRemiseMoney = this.tempRemiseMoney.add(remiseMoeny);
                }
            }
        },
        totalPromoCode() {
            //底部运费折扣码
            let para = {
                code: this.totalAppliquer
            };
            let that = this;
            this.$api.order.queryRemiseCode(para).then(res => {
                //订单优惠券不计算在这里
                if (res.code != 0 || res.data.id_remise_type == 1) return Message.error('code is error');
                that.RemiseCode = res.data;
                that.remiseState = true;
                that.initData();
            });
        },
        closeRemiseState() {
            this.RemiseCode = {};
            this.totalNum.remiseTransport = 0;
            let order_confirm = JSON.parse(JSON.stringify(this.$store.state.order_confirm));
            order_confirm.totalNum = this.totalNum;
            this.$store.commit('set', {key: 'order_confirm', value: order_confirm});
            this.remiseState = false;

            this.initData();
        },
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/confirmation/tableCard.less">
</style>
